import Schema from 'AppReact/schema';
import { required, optional } from 'AppReact/schema';

const button = {
  title: required('string'),
  action: optional('string'),
}

export default {
  selectedIds: Schema('integer', 'array', { defaultValue: [] }),
  ids: Schema('integer', 'array', { defaultValue: [] }),
  buttons: Schema(button, 'array', { defaultValue: [] })
}